// src/components/Utility/Typography.js
import React from 'react';
import Typography from '@mui/material/Typography';

const CustomTypography = ({ variant, color, children, ...props }) => {
    return (
        <Typography
            variant={variant || 'body1'}
            color={color || 'textPrimary'}
            {...props}
        >
            {children}
        </Typography>
    );
};

export default CustomTypography;
